import React from 'react'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import FeedbackLayout from '../../commons/Layouts/FeedbackLayout'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import WomanKey from '../../commons/Ilustrations/WomanKey'

export const TITLE = 'Nova senha redefinada com sucesso!'

export const SUBTITLE = 'Faça login novamente com a nova senha.'

export const PRIMARY_LABEL = 'Login'

const RecoveryPasswordFeedbackContainer = () => {
  return (
    <ExternalLayout>
      <FeedbackLayout
        title={TITLE}
        subTitle={SUBTITLE}
        primaryAction={() => history.push(routes.login.path)}
        primaryLabelAction={PRIMARY_LABEL}
        Ilustration={WomanKey}
      />
    </ExternalLayout>
  )
}

export default RecoveryPasswordFeedbackContainer
